import { render, staticRenderFns } from "./PrimerEditor.vue?vue&type=template&id=152be78f&"
import script from "./PrimerEditor.vue?vue&type=script&lang=js&"
export * from "./PrimerEditor.vue?vue&type=script&lang=js&"
import style0 from "./PrimerEditor.vue?vue&type=style&index=0&id=152be78f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports